module.exports = __webpack_public_path__ + "static/media/Name icon.feaa9826.png";